import React, { useState, useEffect, useMemo } from 'react'
import { supabase } from '../supabaseClient'
import './PermissoesMenus.css'

// Lista de todos os menus disponíveis no sistema com nomes amigáveis
const MENUS_DISPONIVEIS = [
  { id: 'dashboard', nome: '🏠 Dashboard' },
  { id: 'dashboard_v2', nome: '📊 Dashboard V2' },
  { id: 'monitoramento', nome: '🔆 Monitoramento' },
  { id: 'clientes', nome: '🛠️ Instalação (Clientes)' },
  { id: 'clientes_ii', nome: '💼 Gestão de Clientes' },
  { id: 'cadastrar_clientes', nome: '📝 Cadastrar Clientes' },
  { id: 'vendas', nome: '📈 Vendas' },
  { id: 'leads', nome: '🎯 Leads' },
  { id: 'gestao_leads', nome: '🗂️ Gestão Leads' },
  { id: 'cadastrar_leads', nome: '📝 Cadastrar Novo Lead' },
  { id: 'leads_sdr', nome: '📞 Leads SDR' },
  { id: 'leads_capacitacao', nome: '📥 Leads Capacitação' },
  { id: 'presenca', nome: '✅ Presenças' },
  { id: 'colaboradores', nome: '👷 Colaboradores' },
  { id: 'equipes', nome: '👥 Equipes' },
  { id: 'veiculos', nome: '🚗 Veículos' },
  { id: 'cargos', nome: '🎯 Cargos' },
  { id: 'medicao', nome: '📏 Medição' },
  { id: 'lista_material', nome: '📦 Lista de Material' },
  { id: 'pagamento_colaborador', nome: '💰 Pagamento Colaborador' },
  { id: 'adiantamento', nome: '💸 Lançamentos (Adiantamento)' },
  { id: 'ordem_servicos', nome: '🔧 Ordem de Serviços' },
  { id: 'servicos', nome: '📋 Serviços' },
  { id: 'gestao_instalacao', nome: '⚡ Gestão Instalação' },
  { id: 'engenharia_inversores', nome: '🏗️ Engenharia (Inversores)' },
  { id: 'vistorias', nome: '📋 Vistorias' },
  { id: 'engenharia_homologacao', nome: '🏗️ Homologação' },
  { id: 'fluxo_cliente', nome: '🧭 Fluxo do Cliente' },
  { id: 'painel_processos', nome: '📌 Painel de Processos' },
  { id: 'kit_solar', nome: '🔋 Kit Solar' },
  { id: 'cadastro_inversores_modulos', nome: '⚡ Inversores e Módulos' },
  { id: 'monte_seu_kit', nome: '🔧 Monte seu Kit' },
  { id: 'valor_kit', nome: '💵 Valores de Kit' },
  { id: 'kits_personalizados', nome: '🔧 Kits Personalizados' },
  { id: 'kit_fornecedores', nome: '🚚 Kit Fornecedores' },
  { id: 'calculadora_solar', nome: '☀️ Calculadora Solar' },
  { id: 'consulta_propostas', nome: '📄 Consulta de Propostas' },
  { id: 'propostas_cadastro', nome: '📊 Propostas (Cadastro)' },
  { id: 'calendario', nome: '📅 Calendário' },
  { id: 'tipos_servico', nome: '⚙️ Tipos de Serviço' },
  { id: 'tipos_padrao', nome: '⚡ Tipos de Padrão' },
  { id: 'orcamentos', nome: '📋 Orçamentos' },
  { id: 'whatsapp', nome: '💬 WhatsApp CRM / API' },
  { id: 'usuarios', nome: '👤 Usuários' }
]

// Ações do módulo Financeiro (liberadas pelo administrador por usuário)
const ACOES_FINANCEIRO = [
  { id: 'financeiro_autorizar', nome: 'Autorizar (Financeiro)' },
  { id: 'financeiro_baixar', nome: 'Baixar (Financeiro)' },
  { id: 'financeiro_pago', nome: 'Pago (Financeiro)' }
]

// Ações da Gestão de Clientes (liberadas pelo administrador por usuário)
const ACOES_GESTAO_CLIENTES = [
  { id: 'clientes_ii_enviar_clicksign', nome: '✉️ Enviar/Reenviar para assinatura (Clicksign)' }
]

const ACOES_VALOR_KIT = [
  { id: 'valor_kit_consulta', nome: '💵 Valores de Kit — somente consulta (sem incluir, editar ou excluir)' }
]

const PermissoesMenus = ({ onBack, userRole }) => {
  const [usuarios, setUsuarios] = useState([])
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null)
  const [permissoes, setPermissoes] = useState({})
  const [searchUsuario, setSearchUsuario] = useState('')
  const [showUsuarioDropdown, setShowUsuarioDropdown] = useState(false)
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState({ show: false, text: '', type: '' })
  const [showModal, setShowModal] = useState(false)
  const [modalMessage, setModalMessage] = useState({ text: '', type: '' })

  // Filtrar usuários baseado na busca
  const usuariosFiltrados = useMemo(() => {
    if (!searchUsuario.trim()) return []
    
    const searchLower = searchUsuario.toLowerCase()
    return usuarios.filter(usuario => 
      usuario.nome?.toLowerCase().includes(searchLower) ||
      usuario.email?.toLowerCase().includes(searchLower)
    ).slice(0, 10) // Limitar a 10 resultados
  }, [searchUsuario, usuarios])

  useEffect(() => {
    loadUsuarios()
  }, [])

  useEffect(() => {
    if (usuarioSelecionado) {
      loadPermissoesUsuario(usuarioSelecionado.id)
    } else {
      setPermissoes({})
    }
  }, [usuarioSelecionado])

  const loadUsuarios = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('usuarios_sistema')
        .select('id, nome, email, role, status')
        .eq('status', 'ativo')
        .order('nome')

      if (error) throw error
      setUsuarios(data || [])
    } catch (error) {
      console.error('Erro ao carregar usuários:', error)
      showMessage('Erro ao carregar usuários: ' + error.message, 'error')
    } finally {
      setLoading(false)
    }
  }

  const loadPermissoesUsuario = async (usuarioId) => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('permissoes_menus')
        .select('menu_name, permitido')
        .eq('usuario_id', usuarioId)

      if (error) throw error

      // Converter array em objeto para facilitar acesso
      const permissoesObj = {}
      if (data) {
        data.forEach(perm => {
          permissoesObj[perm.menu_name] = perm.permitido
        })
      }
      setPermissoes(permissoesObj)
    } catch (error) {
      console.error('Erro ao carregar permissões:', error)
      showMessage('Erro ao carregar permissões: ' + error.message, 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleSelectUsuario = (usuario) => {
    setUsuarioSelecionado(usuario)
    setSearchUsuario(usuario.nome || usuario.email)
    setShowUsuarioDropdown(false)
  }

  const handleTogglePermissao = (menuId) => {
    if (!usuarioSelecionado) {
      showMessage('Selecione um usuário primeiro', 'warning')
      return
    }

    setPermissoes(prev => {
      const currentValue = prev[menuId] === true
      const next = {
        ...prev,
        [menuId]: !currentValue
      }
      if (menuId === 'valor_kit_consulta' && !currentValue) {
        next.valor_kit = true
      }
      if (menuId === 'valor_kit' && currentValue) {
        next.valor_kit_consulta = false
      }
      return next
    })
  }

  const handleSave = async () => {
    if (!usuarioSelecionado) {
      showMessage('Selecione um usuário primeiro', 'warning')
      return
    }

    try {
      setSaving(true)

      // Preparar dados para inserção/atualização (menus + ações do financeiro)
      const permissoesToSave = [
        ...MENUS_DISPONIVEIS.map(menu => ({
          usuario_id: usuarioSelecionado.id,
          menu_name: menu.id,
          permitido: permissoes[menu.id] === true
        })),
        ...ACOES_FINANCEIRO.map(acao => ({
          usuario_id: usuarioSelecionado.id,
          menu_name: acao.id,
          permitido: permissoes[acao.id] === true
        })),
        ...ACOES_GESTAO_CLIENTES.map(acao => ({
          usuario_id: usuarioSelecionado.id,
          menu_name: acao.id,
          permitido: permissoes[acao.id] === true
        })),
        ...ACOES_VALOR_KIT.map(acao => ({
          usuario_id: usuarioSelecionado.id,
          menu_name: acao.id,
          permitido: permissoes[acao.id] === true
        }))
      ]

      // Deletar todas as permissões existentes do usuário
      const { error: deleteError } = await supabase
        .from('permissoes_menus')
        .delete()
        .eq('usuario_id', usuarioSelecionado.id)

      if (deleteError) throw deleteError

      // Inserir novas permissões
      const { error: insertError } = await supabase
        .from('permissoes_menus')
        .insert(permissoesToSave)

      if (insertError) throw insertError

      // Mostrar modal de sucesso
      setModalMessage({ text: 'Permissões salvas com sucesso!', type: 'success' })
      setShowModal(true)
    } catch (error) {
      console.error('Erro ao salvar permissões:', error)
      setModalMessage({ text: 'Erro ao salvar permissões: ' + error.message, type: 'error' })
      setShowModal(true)
    } finally {
      setSaving(false)
    }
  }

  const handleClear = () => {
    setUsuarioSelecionado(null)
    setSearchUsuario('')
    setPermissoes({})
    setShowUsuarioDropdown(false)
  }

  const showMessage = (text, type = 'success') => {
    setMessage({ show: true, text, type })
    setTimeout(() => {
      setMessage({ show: false, text: '', type: '' })
    }, 5000)
  }

  return (
    <div className="permissoes-menus-container">
      <div className="permissoes-menus-header">
        <h2>🔐 Gerenciar Permissões de Menus</h2>
        {onBack && (
          <button onClick={onBack} className="btn btn-secondary">
            ← Voltar
          </button>
        )}
      </div>

      {message.show && (
        <div className={`alert alert-${message.type === 'error' ? 'danger' : message.type === 'warning' ? 'warning' : 'success'}`}>
          {message.text}
        </div>
      )}

      <div className="permissoes-menus-content">
        {/* Busca de Usuário */}
        <div className="search-usuario-section">
          <label htmlFor="search-usuario">👤 Buscar Usuário:</label>
          <div className="search-dropdown-container">
            <input
              type="text"
              id="search-usuario"
              className="form-control"
              placeholder="Digite o nome ou email do usuário..."
              value={searchUsuario}
              onChange={(e) => {
                setSearchUsuario(e.target.value)
                setShowUsuarioDropdown(true)
                if (!e.target.value) {
                  setUsuarioSelecionado(null)
                  setPermissoes({})
                }
              }}
              onFocus={() => setShowUsuarioDropdown(true)}
            />
            
            {showUsuarioDropdown && usuariosFiltrados.length > 0 && (
              <div className="dropdown-menu show">
                {usuariosFiltrados.map(usuario => (
                  <button
                    key={usuario.id}
                    className="dropdown-item"
                    onClick={() => handleSelectUsuario(usuario)}
                  >
                    <div>
                      <strong>{usuario.nome}</strong>
                      <br />
                      <small>{usuario.email}</small>
                      <br />
                      <small className="text-muted">Role: {usuario.role}</small>
                    </div>
                  </button>
                ))}
              </div>
            )}

            {usuarioSelecionado && (
              <button
                className="btn btn-sm btn-link"
                onClick={handleClear}
                style={{ marginLeft: '10px' }}
              >
                ✕ Limpar
              </button>
            )}
          </div>

          {usuarioSelecionado && (
            <div className="usuario-selecionado-info">
              <strong>Usuário Selecionado:</strong> {usuarioSelecionado.nome} ({usuarioSelecionado.email})
              <br />
              <small>Role: {usuarioSelecionado.role}</small>
            </div>
          )}
        </div>

        {/* Lista de Menus com Checkboxes */}
        {usuarioSelecionado && (
          <div className="menus-permissoes-section">
            <h3>📋 Menus Disponíveis</h3>
            <div className="menus-grid">
              {MENUS_DISPONIVEIS.map(menu => {
                const isChecked = permissoes[menu.id] === true
                return (
                  <div 
                    key={menu.id} 
                    className={`menu-checkbox-item ${isChecked ? 'selected' : ''}`}
                    onClick={(e) => {
                      // Permitir clique em qualquer lugar do card
                      handleTogglePermissao(menu.id)
                    }}
                  >
                    <label className="checkbox-label" onClick={(e) => e.preventDefault()}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => {
                          // Não fazer nada aqui, o onClick do div já cuida disso
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                          handleTogglePermissao(menu.id)
                        }}
                        className="form-check-input"
                      />
                      <span className="menu-name">{menu.nome}</span>
                    </label>
                  </div>
                )
              })}
            </div>

            <h3 className="mt-4">💵 Ações de Valores de Kit</h3>
            <p className="small text-muted mb-2">Marque para liberar a tela só para consulta, sem incluir, editar ou excluir valores.</p>
            <div className="menus-grid mb-3">
              {ACOES_VALOR_KIT.map(acao => {
                const isChecked = permissoes[acao.id] === true
                return (
                  <div
                    key={acao.id}
                    className={`menu-checkbox-item ${isChecked ? 'selected' : ''}`}
                    onClick={() => handleTogglePermissao(acao.id)}
                  >
                    <label className="checkbox-label" onClick={(e) => e.preventDefault()}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => {}}
                        onClick={(e) => { e.stopPropagation(); handleTogglePermissao(acao.id) }}
                        className="form-check-input"
                      />
                      <span className="menu-name">{acao.nome}</span>
                    </label>
                  </div>
                )
              })}
            </div>

            <h3 className="mt-4">💼 Ações da Gestão de Clientes</h3>
            <p className="small text-muted mb-2">Permissões para ações na tela Gestão de Clientes.</p>
            <div className="menus-grid mb-3">
              {ACOES_GESTAO_CLIENTES.map(acao => {
                const isChecked = permissoes[acao.id] === true
                return (
                  <div
                    key={acao.id}
                    className={`menu-checkbox-item ${isChecked ? 'selected' : ''}`}
                    onClick={() => handleTogglePermissao(acao.id)}
                  >
                    <label className="checkbox-label" onClick={(e) => e.preventDefault()}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => {}}
                        onClick={(e) => { e.stopPropagation(); handleTogglePermissao(acao.id) }}
                        className="form-check-input"
                      />
                      <span className="menu-name">{acao.nome}</span>
                    </label>
                  </div>
                )
              })}
            </div>

            <h3 className="mt-4">💰 Ações do Financeiro</h3>
            <p className="small text-muted mb-2">Permissões para Autorizar, Baixar e Marcar como Pago no módulo Financeiro.</p>
            <div className="menus-grid mb-3">
              {ACOES_FINANCEIRO.map(acao => {
                const isChecked = permissoes[acao.id] === true
                return (
                  <div
                    key={acao.id}
                    className={`menu-checkbox-item ${isChecked ? 'selected' : ''}`}
                    onClick={() => handleTogglePermissao(acao.id)}
                  >
                    <label className="checkbox-label" onClick={(e) => e.preventDefault()}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => {}}
                        onClick={(e) => { e.stopPropagation(); handleTogglePermissao(acao.id) }}
                        className="form-check-input"
                      />
                      <span className="menu-name">{acao.nome}</span>
                    </label>
                  </div>
                )
              })}
            </div>

            <div className="permissoes-actions">
              <button
                onClick={handleSave}
                disabled={saving || loading}
                className="btn btn-primary btn-lg"
              >
                {saving ? '⏳ Salvando...' : '💾 Salvar Permissões'}
              </button>
            </div>
          </div>
        )}

        {!usuarioSelecionado && (
          <div className="empty-state">
            <p>🔍 Selecione um usuário para começar a configurar as permissões</p>
          </div>
        )}
      </div>

      {/* Modal de Mensagem */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                {modalMessage.type === 'success' ? '✅ Sucesso!' : '❌ Erro'}
              </h3>
              <button 
                className="modal-close-btn" 
                onClick={() => setShowModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>{modalMessage.text}</p>
            </div>
            <div className="modal-footer">
              <button 
                className="btn btn-primary" 
                onClick={() => setShowModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PermissoesMenus
